module.exports = __webpack_public_path__ + "static/media/Online_Switch_English.b2f3a53f.svg";